import React, { Component } from 'react';
import _ from 'lodash';
const moment = require('moment');
const DatePicker = require('react-bootstrap-date-picker');
var Api = require('./Config');
import { i18nText } from './i18nText';

const getModalDialogForPrinting = (
  askDialogVisible,
  journeys,
  alert,
  setState,
  print_name,
  print_date,
  rtp,
  afterPrint = () => {}
) => {
  if (askDialogVisible != true) {
    return;
  }
  if (journeys.length == 0) {
    alert.open('Error', 'No Patient Selected');
    return;
  }

  const patientParts = Api.getPatientRefParts(journeys[0].patient_ref);
  const patientName = patientParts.mrn + patientParts.patientInitials;

  return (
    <div className="modal show ">
      <div className="modal-dialog modal-sm ">
        <div className="modal-content">
          <div className="modal-header">
            <button
              type="button"
              onClick={() => {
                setState({ askDialogVisible: false });
              }}
              className="close"
              data-dismiss="modal"
            >
              &times;
            </button>
            <h4 className="modal-title">Print Care Plan for</h4>
            <h5 className="modal-title">{patientName} </h5>
          </div>
          <div className="modal-body">
            <div className="form-group">
              <label>Patient Name</label>
              <input
                autoFocus={true}
                value={print_name}
                onChange={(e) => {
                  setState({ print_name: e.target.value });
                }}
                type="text"
                className="form-control"
              />
            </div>

            <div className="form-group">
              <label>Appointment Date</label>
              <DatePicker
                value={print_date}
                onChange={(e) => {
                  setState({ print_date: e });
                }}
              />
            </div>
          </div>
          <div className="modal-footer">
            <div></div>

            <button
              onClick={() => {
                setState({ printMode: true });
                rtp.handlePrint();
                afterPrint();
              }}
              className="btn btn-primary printBTN"
            >
              Print
            </button>
            <button
              onClick={() => {
                setState({ askDialogVisible: false, printMode: false });
                afterPrint();
              }}
              type="button"
              className="btn btn-default"
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const getCarePlanFileName = (print_name) => {
  let carePlanFileName = 'CarePlan';
  if (print_name) {
    carePlanFileName = print_name.replace('.', '') + carePlanFileName;
  }

  return carePlanFileName;
};

export default class CarePlan extends Component {
  constructor(props) {
    super(props);
    this.state = {
      journeys: [],
    };
  }

  componentDidMount() {
    Api.getJourneyMaster(null)
      .then((journeys) => {
        const journeyDesc = journeys.reduce((acc, journey) => {
          acc[journey.JID] = {
            name: journey.patient_title,
            description: journey.journey_description,
          };
          return acc;
        }, []);
        this.setState({ journeys: journeyDesc });
      })
      .catch((err) => {});
  }

  getHeader() {
    return (
      <div style={{ fontSize: 18, fontWeight: 'bold', textAlign: 'center' }}>
        {this.props.title}, {this.props.phone}
      </div>
    );
  }

  getHeaderText(lang) {
    return (
      <div
        style={{ marginTop: 12 }}
        dangerouslySetInnerHTML={{
          __html: i18nText('carePlanHeader', lang),
        }}
      ></div>
    );
  }

  getFooter(lang) {
    var dt = moment(this.props.print_date);
    dt = dt.format('DD MMMM YYYY');

    return (
      <div
        style={{
          paddingLeft: 20,
          paddingRight: 10,
          display: 'flex',
          justifyContent: 'space-between',
          fontSize: 16,
          marginTop: 50,
        }}
      >
        <div>
          {i18nText('carePlanFor', lang)}:
          <span style={{ paddingRight: 50, paddingLeft: 50, borderBottom: '2px solid #888' }}>
            {this.props.print_name}
          </span>{' '}
        </div>
        <div>
          {i18nText('date', lang)}:
          <span style={{ paddingRight: 10, paddingLeft: 10, borderBottom: '2px solid #888' }}>{dt}</span>
        </div>
      </div>
    );
  }

  getFooterText(lang) {
    return (
      <div style={{ marginTop: 20 }}>
        <b style={{ fontSize: 16 }}>{i18nText('yourRole', lang)}</b>
        <p>{i18nText('carePlanFooter', lang)}</p>
      </div>
    );
  }

  getJournies(lang) {
    return (
      <div>
        {_.map(this.props.tcodes, (single, index) => {
          if (single.JID == 2) {
            return null;
          }

          let translatedJID = single.JID;
          if (lang === 'en') {
            if (Object.keys(Api.SPANISH_ENGLISH_JIDS_MAP).includes(single.JID)) {
              translatedJID = Api.SPANISH_ENGLISH_JIDS_MAP[single.JID];
            }
          }

          return (
            <div key={index}>
              <div style={{ marginTop: 20, fontSize: 18 }}>
                <b>
                  {i18nText('journey', lang)}: {this.state.journeys[translatedJID].name}
                </b>
              </div>
              <div style={{ fontSize: 18 }}>
                <b>{i18nText('tcode', lang)}:</b>
                <span
                  style={{
                    paddingRight: 100,
                    fontSize: 18,
                    paddingLeft: 100,
                    borderBottom: '2px solid #888',
                    fontWeight: 'bold',
                  }}
                >
                  {single.t_code}
                </span>
              </div>
              <div style={{ fontSize: 12 }}>{this.state.journeys[translatedJID].description}</div>
            </div>
          );
        })}
      </div>
    );
  }

  getContent(lang) {
    return (
      <React.Fragment>
        {this.getHeader()}
        {this.getHeaderText(lang)}
        {this.getJournies(lang)}
        {this.getFooterText(lang)}
        {this.getFooter(lang)}
      </React.Fragment>
    );
  }

  render() {
    let spanishContent = '';
    if (this.props.tcodes && this.props.tcodes.length > 0) {
      const hasSpanish = this.props.tcodes.filter((tcode) => tcode.lang === 'es');
      if (hasSpanish.length > 0) {
        spanishContent = this.getContent('es');
      }
    }

    return (
      <div style={{ paddingLeft: 10, paddingRight: 10, fontSize: 12 }}>
        {spanishContent}
        <div style={{ pageBreakBefore: 'always' }}>{this.getContent('en')}</div>
      </div>
    );
  }
}

export { getModalDialogForPrinting, getCarePlanFileName };
